import { useState } from "react";
import { ArrowUpRight, LockKeyhole } from "lucide-react";
import { http } from "./api";
import Signup from "./Signup";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [mode, setMode] = useState("login");

  if (mode === "signup") return <Signup onSignup={onLogin} onCancel={() => setMode("login")} />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const r = await http.post("/auth/login", { email, password });
      onLogin(r.data);
    } catch {
      setError("Email or password is incorrect");
    } finally { setBusy(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="login-page">
      <div className="login-art">
        <div className="login-mark mark">84</div>
        <p className="eyebrow">CONSTITUENCY 84 · NABADWIP</p>
        <h1>People-powered<br/><i>progress.</i></h1>
        <p>One clear view of the people, issues, and action shaping Ward 7 — from booth visits to bill of complaints.</p>
        <div className="login-stats">
          <span><b>24</b> booths</span>
          <span><b>4.6k</b> people</span>
          <span><b>18</b> live issues</span>
        </div>
      </div>
      <form className="login-form" onSubmit={submit}>
        <div className="form-brand"><div className="mark">84</div><span>Ward 7 CRM · Jonogoner Swarthe Ward 7</span></div>
        <p className="eyebrow">SECURE WORKSPACE</p>
        <h2>Welcome back</h2>
        <p className="login-sub">Sign in with your workspace account or continue with Google.</p>
        <label>Email address
          <input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label>Password
          <input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        {error && <div className="login-error" data-testid="login-error-message">{error}</div>}
        <button className="primary login-submit" data-testid="login-submit-button" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"} <ArrowUpRight size={16} />
        </button>
        <div className="or"><span>or</span></div>
        <button type="button" className="google" data-testid="google-login-button" onClick={google}>Continue with Google</button>
        <button type="button" className="google" data-testid="signup-open-button" onClick={() => setMode("signup")} style={{ marginTop: 8 }}>Start a new workspace →</button>
        <small className="login-foot"><LockKeyhole size={13} /> Your workspace is protected with role-based access</small>
      </form>
    </div>
  );
}
